import axios from 'axios'
import config from '../config'
import LocalStorageService from './LocalStorageService'

export default function apiLoginFactory () {
  const authorization = LocalStorageService.getAuthorization()

  return axios.create({
    baseURL: config.LOGIN_BACKEND_URL,
    headers: { authorization }
  })
}
